import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpService } from '../../services/http.service';
import { GtmService } from '../../services/gtm.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search-structure',
  imports: [TranslateModule],
  templateUrl: './search-structure.component.html',
  styleUrl: './search-structure.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchStructureComponent {
  @Input() textPointer?: string;

  constructor(
    private http: HttpService,
    private gtmService: GtmService,
    private router: Router
  ) {}

  generateDigitalCardLink() {
    this.gtmService.pushFindStructureEvent();
    const userDataString = localStorage.getItem('userData');

    if (!userDataString) {
      console.error('Nessun dato utente trovato in localStorage');
      return;
    }

    try {
      const userData = JSON.parse(userDataString);
      const expirationDate = new Date(userData.expirationDate).toLocaleDateString('it-IT');

      this.router.navigate(['/digitalcard'], {
        queryParams: {
          expirationDate: expirationDate,
          name: userData.name,
          surname: userData.surname,
          taxId: userData.taxId,
        },
      });
    } catch (error) {
      console.error('Errore nel parsing di userData:', error);
    }
  }

  openDossier(): void {
    const individualId = JSON.parse(localStorage.getItem('userData')!)?.individualId;

    this.http.openDossier(individualId, individualId).subscribe({
      next: async (response) => {
        if (!response?.result) {
          return;
        }

        let url = 'https://www.welion.it/salute/trova-strutture';
        if (this.textPointer === 'MNF') {
          url = 'https://ricercastruttureconvenzionate.fasdac.it';
        }

        await this.openExternalUrl(url);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  private async openExternalUrl(url: string): Promise<void> {
    const w = window as any;

    try {
      // Bridge MAUI/HybridWebView
      if (w.HybridWebView && typeof w.HybridWebView.InvokeDotNet === 'function') {
        await w.HybridWebView.InvokeDotNet('OpenExternalUrl', JSON.stringify({ url }));
        return;
      }

      // Eventuale bridge custom legacy
      if (w.chrome?.webview?.postMessage) {
        w.chrome.webview.postMessage({ type: 'openExternalUrl', url });
        return;
      }

      // Fallback browser classico
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (e) {
      console.error('Errore apertura URL esterno', e);
    }
  }
}
